<span class="color-text {{ color ? 'color-text--' + color : '' }} {{ size ? 'color-text--size-' + size : '' }}">
  <ng-content></ng-content>
</span>
